/**
 * 문제 관련 API 서비스
 * 학생용 문제 조회 및 진도 확인
 */

import axiosInstance from '../config/axios';

/**
 * 페이지 문제 목록 조회 (제출 가능 여부 포함)
 *
 * GET /api/v1/student/workbooks/{workbook_name}/page/{page}/problems
 *
 * @param workbookName - 문제집명
 * @param page - 페이지 번호
 * @returns 문제 목록 + 제출 이력
 */
export const getPageProblems = async (
  workbookName: string,
  page: number
): Promise<any> => {
  try {
    const response = await axiosInstance.get(
      `/student/workbooks/${encodeURIComponent(workbookName)}/page/${page}/problems`
    );
    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch page problems:', error);
    throw error;
  }
};

/**
 * 문제집 진도 조회
 *
 * GET /api/v1/student/workbooks/{workbook_name}/progress
 *
 * @param workbookName - 문제집명
 * @returns 페이지별 진도
 */
export const getWorkbookProgress = async (
  workbookName: string
): Promise<any> => {
  try {
    const response = await axiosInstance.get(
      `/student/workbooks/${encodeURIComponent(workbookName)}/progress`
    );
    return response.data;
  } catch (error: any) {
    console.error('Failed to fetch workbook progress:', error);
    throw error;
  }
};
